export const defaultValues = {
  name: '',
  email: '',
  phone: '',
  status: true,
  scopes: [],
};
